<template>
  <ContentWrap>
    <el-form :inline="true" :model="query" class="-mb-15px" @submit.prevent>
      <el-form-item label="用户昵称">
        <el-input
          v-model="query.userNickname"
          clearable
          class="!w-180px"
          placeholder="请输入用户昵称"
          @keyup.enter="search"
        />
      </el-form-item>
      <el-form-item v-if="certType === 1" label="姓名">
        <el-input
          v-model="query.realName"
          clearable
          class="!w-160px"
          placeholder="请输入姓名"
          @keyup.enter="search"
        />
      </el-form-item>
      <el-form-item v-if="certType === 2" label="企业名称">
        <el-input
          v-model="query.companyName"
          clearable
          class="!w-180px"
          placeholder="请输入企业名称"
          @keyup.enter="search"
        />
      </el-form-item>
      <el-form-item v-if="certType === 2" label="执照编号">
        <el-input
          v-model="query.businessLicenseNo"
          clearable
          class="!w-200px"
          placeholder="企业编号/统一社会信用代码"
          @keyup.enter="search"
        />
      </el-form-item>
      <el-form-item label="申请时间">
        <el-date-picker
          v-model="applyRange"
          type="datetimerange"
          value-format="YYYY-MM-DD HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          class="!w-360px"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search"
          ><Icon class="mr-5px" icon="ep:search" />查询</el-button
        >
        <el-button @click="reset"><Icon class="mr-5px" icon="ep:refresh" />重置</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-tabs v-model="query.auditStatus" @tab-change="changeTab">
      <el-tab-pane :label="`待审核(${counts[0]})`" :name="0" />
      <el-tab-pane :label="`已通过(${counts[1]})`" :name="1" />
      <el-tab-pane :label="`已驳回(${counts[2]})`" :name="2" />
    </el-tabs>
    <div class="mb-12px">
      <el-button
        v-hasPermi="['bosscircle:certification:audit']"
        type="success"
        plain
        :disabled="!selectedRows.length"
        @click="batchAudit(1)"
      >
        <Icon class="mr-5px" icon="ep:circle-check" />批量通过
      </el-button>
      <el-button
        v-hasPermi="['bosscircle:certification:audit']"
        type="danger"
        plain
        :disabled="!selectedRows.length"
        @click="batchAudit(2)"
      >
        <Icon class="mr-5px" icon="ep:circle-close" />批量驳回
      </el-button>
      <span v-if="selectedRows.length" class="ml-10px text-12px text-#909399"
        >已选择 {{ selectedRows.length }} 项</span
      >
    </div>

    <el-table
      v-loading="loading"
      :data="list"
      row-key="id"
      @selection-change="selectedRows = $event"
    >
      <el-table-column type="selection" width="45" :selectable="canSelectRow" />
      <el-table-column label="用户昵称" min-width="140">
        <template #default="{ row }">{{ row.userNickname || `用户${row.userId}` }}</template>
      </el-table-column>
      <template v-if="certType === 1">
        <el-table-column prop="realName" label="姓名" min-width="110" />
        <el-table-column prop="idCard" label="身份证" min-width="180" />
        <el-table-column label="身份证正面" width="110">
          <template #default="{ row }"
            ><el-image
              v-if="row.idCardFront"
              :src="row.idCardFront"
              :preview-src-list="[row.idCardFront]"
              class="!h-52px !w-80px"
              fit="cover"
            /><span v-else>-</span></template
          >
        </el-table-column>
        <el-table-column label="身份证反面" width="110">
          <template #default="{ row }"
            ><el-image
              v-if="row.idCardBack"
              :src="row.idCardBack"
              :preview-src-list="[row.idCardBack]"
              class="!h-52px !w-80px"
              fit="cover"
            /><span v-else>-</span></template
          >
        </el-table-column>
      </template>
      <template v-else>
        <el-table-column prop="companyName" label="企业名称" min-width="160" show-overflow-tooltip />
        <el-table-column
          prop="businessLicenseNo"
          label="企业编号代码"
          min-width="180"
          show-overflow-tooltip
        />
        <el-table-column prop="mobile" label="手机号码" min-width="120" />
        <el-table-column label="营业执照" width="100">
          <template #default="{ row }"
            ><el-image
              v-if="row.businessLicenseImage"
              :src="row.businessLicenseImage"
              :preview-src-list="[row.businessLicenseImage]"
              class="!h-52px !w-80px"
              fit="cover"
            /><span v-else>-</span></template
          >
        </el-table-column>
        <el-table-column label="身份证正面" width="100">
          <template #default="{ row }"
            ><el-image
              v-if="row.idCardFront"
              :src="row.idCardFront"
              :preview-src-list="[row.idCardFront]"
              class="!h-52px !w-80px"
              fit="cover"
            /><span v-else>-</span></template
          >
        </el-table-column>
        <el-table-column label="身份证反面" width="100">
          <template #default="{ row }"
            ><el-image
              v-if="row.idCardBack"
              :src="row.idCardBack"
              :preview-src-list="[row.idCardBack]"
              class="!h-52px !w-80px"
              fit="cover"
            /><span v-else>-</span></template
          >
        </el-table-column>
      </template>
      <el-table-column label="状态" width="100"
        ><template #default="{ row }"
          ><el-tag :type="statusType(row.auditStatus)">{{
            statusText(row.auditStatus)
          }}</el-tag></template
        ></el-table-column
      >
      <el-table-column label="支付" width="110">
        <template #default="{ row }">
          <span>{{ payStatusText(row) }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="query.auditStatus === 1" label="徽标" width="100">
        <template #default="{ row }">
          <el-tag :type="row.badgeHidden === 1 ? 'info' : 'success'" size="small">
            {{ row.badgeHidden === 1 ? '已隐藏' : '展示中' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="auditRemark" label="审核备注" min-width="160" show-overflow-tooltip />
      <el-table-column prop="createTime" label="申请时间" :formatter="dateFormatter" width="180" />
      <el-table-column label="操作" width="200" fixed="right">
        <template #default="{ row }">
          <el-button link @click="openDetail(row)">详情</el-button>
          <el-button
            v-if="row.auditStatus === 0"
            v-hasPermi="['bosscircle:certification:audit']"
            link
            type="primary"
            @click="openAudit(row)"
            >审核</el-button
          >
          <el-button
            v-if="row.auditStatus === 1 && row.badgeHidden !== 1"
            v-hasPermi="['bosscircle:certification:audit']"
            link
            type="warning"
            @click="hideBadge(row)"
            >隐藏徽标</el-button
          >
          <el-button
            v-if="row.auditStatus === 1 && row.badgeHidden === 1"
            v-hasPermi="['bosscircle:certification:audit']"
            link
            type="success"
            @click="showBadge(row)"
            >恢复展示</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>

  <Dialog v-model="detailVisible" title="认证详情" width="1200px">
    <el-descriptions :column="4" border class="cert-desc" label-width="96px">
      <el-descriptions-item
        v-for="item in detailItems"
        :key="item.label"
        :label="item.label"
        :span="item.span || 1"
      >
        <el-image
          v-if="item.type === 'image' && item.value"
          :src="item.value"
          :preview-src-list="[item.value]"
          preview-teleported
          class="cert-desc__img"
          fit="contain"
        />
        <span v-else>{{ item.value }}</span>
      </el-descriptions-item>
    </el-descriptions>
    <template #footer>
      <el-button @click="detailVisible = false">关闭</el-button>
    </template>
  </Dialog>
  <!-- 上方资料 + 下方审核操作 -->
  <Dialog v-model="auditVisible" title="认证审核" width="1200px">
    <el-descriptions :column="4" border class="mb-16px cert-desc" label-width="96px">
      <el-descriptions-item label="申请人" :span="2">{{
        detail.userNickname || `用户${detail.userId}`
      }}</el-descriptions-item>
      <el-descriptions-item
        v-for="item in detailItems"
        :key="'a-' + item.label"
        :label="item.label"
        :span="item.span || 1"
      >
        <el-image
          v-if="item.type === 'image' && item.value"
          :src="item.value"
          :preview-src-list="[item.value]"
          preview-teleported
          class="cert-desc__img"
          fit="contain"
        />
        <span v-else>{{ item.value }}</span>
      </el-descriptions-item>
    </el-descriptions>
    <el-divider content-position="left">审核操作</el-divider>
    <el-form label-width="96px">
      <el-form-item label="审核结果">
        <el-radio-group v-model="audit.auditStatus">
          <el-radio :value="1">通过</el-radio>
          <el-radio :value="2">驳回</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="audit.auditStatus === 2" label="驳回原因" required>
        <el-input
          v-model="audit.auditRemark"
          type="textarea"
          :rows="2"
          maxlength="200"
          show-word-limit
          placeholder="请填写驳回原因"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="auditVisible = false">关闭</el-button>
      <el-button type="primary" :loading="auditSaving" @click="submitAudit">提交审核</el-button>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { dateFormatter, formatDate } from '@/utils/formatTime'
import * as Api from '@/api/business/certification'

defineOptions({ name: 'BossCircleCertification' })

const props = withDefaults(
  defineProps<{
    /** 微名片等外层指定认证类型；不传则按路由 /enterprise 判断 */
    certTypeProp?: number
  }>(),
  { certTypeProp: 0 }
)

type Certification = {
  id: number
  userId: number
  userNickname?: string
  certType: number
  realName?: string
  idCard?: string
  idCardFront?: string
  idCardBack?: string
  companyName?: string
  contactName?: string
  mobile?: string
  wechat?: string
  address?: string
  industry?: string
  businessMode?: string
  businessLicenseNo?: string
  businessLicenseImage?: string
  auditStatus: number
  auditRemark?: string
  badgeHidden?: number
  badgeHiddenReason?: string
  payStatus?: number
  payOrderId?: number
  tradeOrderId?: number
  paidAmount?: number
  paidTime?: string
  createTime?: string
}

const route = useRoute()
const message = useMessage()
const loading = ref(false)
const list = ref<Certification[]>([])
const selectedRows = ref<Certification[]>([])
const total = ref(0)
const counts = reactive<Record<number, number>>({ 0: 0, 1: 0, 2: 0 })
const detail = ref<Certification>({} as Certification)
const detailVisible = ref(false)
const auditVisible = ref(false)
const auditSaving = ref(false)
const applyRange = ref<string[]>([])
const certType = computed(() => {
  if (props.certTypeProp === 1 || props.certTypeProp === 2) return props.certTypeProp
  return /enterprise/i.test(route.path) ? 2 : 1
})
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  certType: certType.value,
  auditStatus: 0,
  userNickname: '',
  realName: '',
  companyName: '',
  businessLicenseNo: ''
})
const audit = reactive({ id: 0, auditStatus: 1, auditRemark: '' })

const statusText = (status: number) => ['待审核', '已通过', '已驳回'][status] || '未知'
const statusType = (status: number) =>
  status === 1 ? 'success' : status === 2 ? 'danger' : 'warning'
const payStatusText = (row: Certification) => {
  const map: Record<number, string> = { 0: '免费/未付', 1: '待支付', 2: '已支付', 3: '已关闭' }
  return map[Number(row.payStatus ?? 0)] || '未知'
}
const payAmountText = (row: Certification) => {
  if (row.paidAmount == null) return '-'
  return `¥${(Number(row.paidAmount) / 100).toFixed(2)}`
}
const canSelectRow = (row: Certification) => row.auditStatus === 0 && Number(row.payStatus) !== 1

type DetailItem = {
  label: string
  value?: string | number | null
  type?: string
  span?: number
}
const isFilled = (item: DetailItem) => {
  if (item.type === 'image') return !!item.value
  if (item.value === null || item.value === undefined || item.value === '') return false
  if (item.value === '-') return false
  return true
}
const formatPaidTime = (d: Certification) => {
  const raw = d.paidTime || (Number(d.payStatus) === 2 ? d.createTime : undefined)
  if (!raw) return undefined
  return formatDate(raw as any) || String(raw)
}
/** 把未占满的行并入上一项 span，保证每段从新行起排，避免图文错位 */
const fillRow = (items: DetailItem[], columns = 4): DetailItem[] => {
  const out: DetailItem[] = []
  let used = 0
  for (const raw of items) {
    const item: DetailItem = { ...raw, span: Math.min(raw.span || 1, columns) }
    if (used > 0 && used + (item.span || 1) > columns) {
      const last = out[out.length - 1]
      last.span = (last.span || 1) + (columns - used)
      used = 0
    }
    out.push(item)
    used += item.span || 1
    if (used >= columns) used = 0
  }
  if (used > 0 && out.length) {
    const last = out[out.length - 1]
    last.span = (last.span || 1) + (columns - used)
  }
  return out
}

const detailItems = computed(() => {
  const d = detail.value
  const badgeText =
    d.auditStatus === 1
      ? d.badgeHidden === 1
        ? `已隐藏${d.badgeHiddenReason ? '：' + d.badgeHiddenReason : ''}`
        : '展示中'
      : undefined
  // 文案区 / 图片区 / 支付区分段排版：身份证正面与支付状态都从第 1 列起，上下对齐
  const textItems: DetailItem[] =
    d.certType === 1
      ? [
          { label: '姓名', value: d.realName },
          { label: '手机号', value: d.mobile },
          { label: '微信号', value: d.wechat },
          { label: '行业', value: d.industry },
          { label: '身份证号', value: d.idCard, span: 2 },
          { label: '联系地址', value: d.address, span: 2 },
          { label: '徽标', value: badgeText }
        ]
      : [
          { label: '企业名称', value: d.companyName, span: 2 },
          { label: '企业编号代码', value: d.businessLicenseNo, span: 2 },
          { label: '经营方式', value: d.businessMode },
          { label: '法人姓名', value: d.contactName },
          { label: '手机号码', value: d.mobile },
          { label: '行业', value: d.industry },
          { label: '身份证号', value: d.idCard, span: 2 },
          { label: '徽标', value: badgeText }
        ]
  const imageItems: DetailItem[] =
    d.certType === 1
      ? [
          { label: '身份证正面', value: d.idCardFront, type: 'image' },
          { label: '身份证反面', value: d.idCardBack, type: 'image' }
        ]
      : [
          // span=1，与下方「支付状态」同列，落在其正上方
          { label: '身份证正面', value: d.idCardFront, type: 'image' },
          { label: '身份证反面', value: d.idCardBack, type: 'image' },
          { label: '营业执照照片', value: d.businessLicenseImage, type: 'image', span: 2 }
        ]
  const payItems: DetailItem[] = [
    { label: '支付状态', value: payStatusText(d) },
    { label: '实付金额', value: d.paidAmount != null ? payAmountText(d) : undefined },
    { label: '支付单号', value: d.payOrderId },
    { label: '统一订单号', value: d.tradeOrderId },
    { label: '支付时间', value: formatPaidTime(d) },
    {
      label: '申请时间',
      value: d.createTime ? formatDate(d.createTime as any) || d.createTime : undefined
    }
  ]
  return [
    ...fillRow(textItems.filter(isFilled)),
    ...fillRow(imageItems.filter(isFilled)),
    ...fillRow(payItems.filter(isFilled))
  ]
})

async function load() {
  loading.value = true
  try {
    const data = await Api.getCertificationPage({
      ...query,
      certType: certType.value,
      realName: certType.value === 1 ? query.realName : undefined,
      companyName: certType.value === 2 ? query.companyName : undefined,
      businessLicenseNo: certType.value === 2 ? query.businessLicenseNo : undefined,
      createTimeStart: applyRange.value?.[0],
      createTimeEnd: applyRange.value?.[1]
    })
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}
const loadCounts = async () => Object.assign(counts, await Api.getAuditCounts(certType.value))
const refresh = async () => Promise.all([load(), loadCounts()])
const search = () => {
  query.pageNo = 1
  load()
}
const reset = () => {
  Object.assign(query, {
    pageNo: 1,
    auditStatus: 0,
    userNickname: '',
    realName: '',
    companyName: '',
    businessLicenseNo: ''
  })
  applyRange.value = []
  load()
}
const changeTab = (name: string | number) => {
  query.auditStatus = Number(name)
  query.pageNo = 1
  selectedRows.value = []
  load()
}
const openDetail = (row: Certification) => {
  detail.value = row
  detailVisible.value = true
}
const openAudit = (row: Certification) => {
  detail.value = row
  Object.assign(audit, { id: row.id, auditStatus: 1, auditRemark: '' })
  auditVisible.value = true
}

async function submitAudit() {
  if (audit.auditStatus === 2 && !audit.auditRemark.trim()) return message.warning('请填写驳回原因')
  auditSaving.value = true
  try {
    await Api.auditCertification(audit)
    auditVisible.value = false
    message.success('审核完成')
    await refresh()
  } finally {
    auditSaving.value = false
  }
}

async function batchAudit(status: number) {
  const ids = selectedRows.value.filter(canSelectRow).map((row) => row.id)
  if (!ids.length) return
  const remark =
    status === 2
      ? (await message.prompt('请输入驳回原因', `批量驳回 ${ids.length} 项`)).value
      : (await message.confirm(`确认批量通过选中的 ${ids.length} 项认证申请吗？`), undefined)
  await Api.batchAuditCertification(ids, status, remark)
  selectedRows.value = []
  message.success('批量审核完成')
  await refresh()
}

async function hideBadge(row: Certification) {
  const reason = (await message.prompt('请输入隐藏原因', '隐藏公域徽标')).value
  if (!reason?.trim()) return message.warning('请填写隐藏原因')
  await Api.updateCertificationBadgeHidden({ id: row.id, hidden: true, reason: reason.trim() })
  message.success('已隐藏徽标')
  await refresh()
}

async function showBadge(row: Certification) {
  await message.confirm('确认恢复公域徽标展示吗？')
  await Api.updateCertificationBadgeHidden({ id: row.id, hidden: false })
  message.success('已恢复展示')
  await refresh()
}

watch(
  () => route.path,
  () => {
    query.pageNo = 1
    selectedRows.value = []
    refresh()
  }
)
onMounted(refresh)
</script>

<style scoped lang="scss">
.cert-desc :deep(.el-descriptions__label) {
  width: 100px;
  font-weight: 600;
  color: #606266;
}
.cert-desc :deep(.el-descriptions__content) {
  word-break: break-all;
}
.cert-desc__img {
  width: 88px;
  height: 56px;
  border: 1px solid #ebeef5;
  background: #f5f7fa;
}
</style>
